import { render, staticRenderFns } from "./ModalNps.vue?vue&type=template&id=25e9027e&scoped=true&"
import script from "./ModalNps.vue?vue&type=script&lang=js&"
export * from "./ModalNps.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=25e9027e&scoped=true&lang=css&"
import style1 from "./ModalNps.vue?vue&type=style&index=1&id=25e9027e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e9027e",
  null
  
)

export default component.exports